import React from 'react'
import { VStack } from '../../bases/VStack'
import { HStack } from '../../bases/HStack'
import { Text } from '../../bases/Text'
import { NotificationsQuery } from './query.generated'
import { Paging, Props as PagingProps } from '../Paging/Paging'
import { getTitleAndDetails } from './constants'
import { Center } from '../../bases/Center'
import Image from 'next/image'
import NoData from '@/public/images/noData.png'
import { convertDisplayDate } from '@/src/utils/DateUtils'

export type Props = {
  notifications: NotificationsQuery['currentUserNotifications']
  paging: PagingProps
}

export const Layout: React.VFC<Props> = (props) => {
  const { notifications, paging } = props
  const { allCount, maxPage, currentPage, onClickPage } = paging

  return (
    <VStack className="h-full w-full overflow-hidden rounded-2xl border border-[#805BE7]  bg-black">
      <VStack className="blue_scroll_bar w-full flex-1 overflow-x-hidden overflow-y-scroll">
        {notifications.length > 0 ? (
          notifications.map((n, index) => {
            try {
              const { title, details } = getTitleAndDetails(n)
              return (
                <HStack key={n.id} className={`p-5 ${index % 2 === 0 ? 'bg-black' : 'bg-[#1A122E]'}`}>
                  <VStack className="ml-4 flex-1">
                    <Text className=" text-white">{title}</Text>
                    <VStack className="ml-4">
                      {details?.map((m) => (
                        <Text key={m} className=" text-white">
                          {m}
                        </Text>
                      ))}
                    </VStack>
                  </VStack>
                  <Text className="text-white">{convertDisplayDate(n.createdAt)}</Text>
                </HStack>
              )
            } catch (e) {
              console.log(e)
              return <></>
            }
          })
        ) : (
          <Center className="h-full w-full">
            <Image width={140} height={140} src={NoData} alt="No Data" />
          </Center>
        )}
      </VStack>
      <Paging allCount={allCount} maxPage={maxPage} currentPage={currentPage} onClickPage={onClickPage} />
    </VStack>
  )
}
